// GlobalRefreshTimer
import { PropsWithChildren, createContext, useContext } from 'react';
import { Outlet } from 'react-router-dom';
import { REFRESH_DATA_TTL } from 'configs/common';
import { useRefreshTimer } from 'hooks';

// ! CONTEXT LOGIC HOOK
const useGlobalRefreshTimerLogic = () => {
	const refreshTimer = useRefreshTimer(REFRESH_DATA_TTL);

	return refreshTimer;
};

// ! CONTEXT
type IGlobalRefreshTimerContextData = ReturnType<typeof useGlobalRefreshTimerLogic>;
const GlobalRefreshTimerContext = createContext<IGlobalRefreshTimerContextData | undefined>(undefined);

// ! CONTEXT PROVIDER
export const GlobalRefreshTimerProvider = ({ children = <Outlet /> }: PropsWithChildren) => {
	const value = useGlobalRefreshTimerLogic();

	return <GlobalRefreshTimerContext.Provider value={value}>{children}</GlobalRefreshTimerContext.Provider>;
};

// ! CONTEXT CONSUMER HOOK
export const useGlobalRefreshTimer = () => {
	const ctx = useContext(GlobalRefreshTimerContext);

	if (!ctx) {
		throw new Error('useGlobalRefreshTimer must be used inside GlobalRefreshTimerProvider');
	}

	return ctx;
};
